
angular.module('cesium.controllers', [
  'cesium.app.controllers',
  'cesium.home.controllers',
  'cesium.feed.controllers',
  'cesium.join.controllers',
  'cesium.login.controllers',
  'cesium.help.controllers',
  'cesium.wallet.controllers',
  'cesium.wallets.controllers',
  'cesium.currency.controllers',
  'cesium.wot.controllers',
  'cesium.transfer.controllers',
  'cesium.settings.controllers',
  'cesium.network.controllers',
  'cesium.blockchain.controllers'
]);
